import { useEffect } from 'react';

const CalendlyRedirect = () => {
  useEffect(() => {
    // Redirect to the Calendly URL immediately when component mounts
    window.location.href = 'https://calendly.com/bb-global-solutions/discovery';
  }, []);

  // Show loading message briefly before redirect
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#333'
    }}>
      Redirecting to Calendly...
    </div>
  );
};

export default CalendlyRedirect; 